import { useState } from "react";
import { useListsContext } from "../ListsContext";
import {
  SelectAllLabel,
  SmallButton,
  StagePill,
  StagePills,
  ToolbarRow,
} from "../Lists.styled";
import { ListItem } from "../types";
import { ConfirmModal } from "./ConfirmModal";

// Check-everything pill, with Delete Checked alongside it once there is something to
// clear. Both act on the whole list, so they belong on the same row.
export function SelectAllRow(props: { listId: string; items: ListItem[] }) {
  const { setAllChecked, deleteChecked } = useListsContext();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const checkedCount = props.items.filter((item) => item.Checked).length;
  const allChecked = checkedCount === props.items.length;
  const someChecked = checkedCount > 0 && !allChecked;

  // Deleting several items at once is worth a prompt even though they are all checked,
  // because unlike a single row it cannot be undone by re-adding one thing.
  function deleteMessage() {
    const items = checkedCount === 1 ? "item" : "items";
    return `Delete ${checkedCount} checked ${items} from this list? This cannot be undone.`;
  }

  return (
    <ToolbarRow>
      {/* The master pill mirrors the rows' own pill, so "tick everything" looks like
          the thing it ticks. Half-filled while the list is only partly done. */}
      <SelectAllLabel>
        All:
        <StagePills>
          <StagePill
            type="button"
            $on={allChecked}
            $mixed={someChecked}
            role="checkbox"
            aria-checked={someChecked ? "mixed" : allChecked}
            onClick={() => setAllChecked(props.listId, !allChecked)}
          >
            Done
          </StagePill>
        </StagePills>
      </SelectAllLabel>
      {checkedCount > 0 && (
        <SmallButton type="button" onClick={() => setConfirmOpen(true)}>
          Delete Checked ({checkedCount})
        </SmallButton>
      )}
      {confirmOpen && (
        <ConfirmModal
          heading="Delete Checked Items"
          message={deleteMessage()}
          confirmLabel="Delete Checked"
          onConfirm={() => deleteChecked(props.listId)}
          onClose={() => setConfirmOpen(false)}
        />
      )}
    </ToolbarRow>
  );
}
